"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var swiper_1 = require("swiper");
var swr_hooks_2 = require("@l2p/swr-hooks");
var react_2 = require("swiper/react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var ui_components_1 = require("@l2p/ui-components");
var OnVariousTheme = function (_a) {
    var _b;
    var categoriesToShow = _a.categoriesToShow, _c = _a.mobileSlidesPerView, mobileSlidesPerView = _c === void 0 ? 2 : _c;
    var slider = (0, react_1.useRef)(null);
    var config = (0, swr_hooks_2.useConfig)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var gamesByCategories = (0, swr_hooks_1.useGamesByCategories)().data;
    var viewAllHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/all"));
    }, [router, generateUrlWithLang]);
    var gamesByTheme = (0, react_1.useMemo)(function () {
        return categoriesToShow
            .filter(function (collection) { return collection.place === 'byTheme'; })
            .map(function (item) { return item.slug; });
    }, [categoriesToShow]);
    var preparedCollections = (0, react_1.useMemo)(function () {
        var result = [];
        if (gamesByCategories)
            gamesByTheme.forEach(function (collection) {
                var _a, _b, _c;
                var games = ((_a = gamesByCategories[collection]) === null || _a === void 0 ? void 0 : _a.previewGames) || [];
                if (games && games.length > 0)
                    result.push({
                        collectionSlug: collection,
                        title: ((_b = gamesByCategories[collection]) === null || _b === void 0 ? void 0 : _b.title) || '',
                        games: (games === null || games === void 0 ? void 0 : games.slice(0, 5)) || [],
                        count: (_c = gamesByCategories[collection]) === null || _c === void 0 ? void 0 : _c.gameCount,
                    });
            });
        return result;
    }, [gamesByTheme, gamesByCategories]);
    var onClickHandler = (0, react_1.useCallback)(function (slug) {
        router.push(generateUrlWithLang("/games/".concat(slug)));
    }, [generateUrlWithLang, router]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h1", null, t('onVariousThemeHeader')))),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.themes, " on-various-theme") },
            react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                    slider.current = swiper;
                }, className: styles_module_scss_1.default.swiper, modules: [swiper_1.Pagination, swiper_1.Navigation], loop: true, loopAdditionalSlides: 1, spaceBetween: 12, slidesPerView: breakpoints.mobile && ((_b = Object.keys(breakpoints)) === null || _b === void 0 ? void 0 : _b.length) > 0
                    ? mobileSlidesPerView
                    : 4, pagination: { clickable: true }, navigation: true, initialSlide: 2, autoplay: false }, preparedCollections.map(function (c) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "onVariousTheme_".concat(c.collectionSlug) },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.theme), style: {
                        backgroundImage: "url('/img/on-various-theme/".concat(c === null || c === void 0 ? void 0 : c.collectionSlug, ".png')"),
                    }, onClick: function () { return onClickHandler(c.collectionSlug); } },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.borderGradient }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.name }, translateLocale(c.title)),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.count }, t('onVariousThemeItemMore', { count: c.count }))))); }))),
        (config === null || config === void 0 ? void 0 : config.onVariousThemeViewAll) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper },
            react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: viewAllHandler }, t('viewAll')))) : null));
};
exports.default = OnVariousTheme;
